import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import AllProjects from "./components/AllProjects";
import Unauthorized from "./components/Unauthorized";
import GoogleOauthCallbackEntry from "./components/business/GoogleOauthCallbackEntry";
import {
  canAccessAllProjects,
  getPostLoginPath,
  getToken,
  isAdminUser,
} from "./utils/auth";
import {
  isAllProjectsPath,
  isAuthRoute,
  isBusinessAppPath,
  isGoogleOauthCallbackPath,
  isLoginEntryPath,
  isUnauthorizedPath,
  normalizePath,
} from "./routes/pathUtils";
import PublicAuthApp from "./routes/PublicAuthApp";
import BusinessApp from "./routes/BusinessApp";
import AdminApp from "./routes/AdminApp";

function AppContent() {
  const location = useLocation();
  const path = normalizePath(location.pathname);
  const [adminNavOpen, setAdminNavOpen] = useState(false);
  const signedIn = Boolean(getToken());

  useEffect(() => {
    setAdminNavOpen(false);
  }, [location.pathname]);

  // Google returns here, then we open the project GoogleOauthCallback page
  if (isGoogleOauthCallbackPath(path)) {
    if (!signedIn) {
      return <Navigate to="/login" replace />;
    }
    return (
      <div className="App">
        <GoogleOauthCallbackEntry />
      </div>
    );
  }

  // Already signed in: skip home/login and go to that user's dashboard
  if (isLoginEntryPath(path) && signedIn) {
    return <Navigate to={getPostLoginPath()} replace />;
  }

  if (isUnauthorizedPath(path)) {
    return (
      <div className="App">
        <Routes>
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Routes>
      </div>
    );
  }

  // Home, login, register, and other public pages
  if (isAuthRoute(path)) {
    return <PublicAuthApp />;
  }

  if (!signedIn) {
    return <Navigate to="/login" replace />;
  }

  // Admin home
  if (isAllProjectsPath(path)) {
    if (!canAccessAllProjects()) {
      return <Navigate to={getPostLoginPath()} replace />;
    }
    return (
      <div className="App">
        <Routes>
          <Route path="/all-projects" element={<AllProjects />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Routes>
      </div>
    );
  }

  // Project workspace
  if (isBusinessAppPath(path)) {
    return <BusinessApp />;
  }

  // Remaining admin tools (docs, billing, …)
  if (!isAdminUser()) {
    return <Navigate to={getPostLoginPath()} replace />;
  }

  return (
    <AdminApp
      navOpen={adminNavOpen}
      onToggleNav={() => setAdminNavOpen((open) => !open)}
      onCloseNav={() => setAdminNavOpen(false)}
    />
  );
}

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppContent />
    </Router>
  );
}

export default App;
